const steps = [
  {
    label: "The Problem",
    headline: (
      <>
        Most people don’t have a <em className="italic text-[#C07865]">stress</em> problem.
        <br />
        They have a <em className="italic text-[#C07865]">reactivity</em> problem.
      </>
    ),
    items: [
      "Overthinking",
      "Emotional overwhelm",
      "Constant pressure",
      "Feeling pulled in every direction",
    ],
  },
  {
    label: "The Shift",
    headline: (
      <>
        Anchor teaches you<br />how to <em className="italic text-[#C07865]">return</em>.
      </>
    ),
    items: [
      "Pause in real time",
      "Regulate your nervous system",
      "Stop mental spirals",
      "Return to a grounded state",
    ],
  },
  {
    label: "How It Works",
    headline: (
      <>
        A simple<br />
        <em className="italic text-[#C07865]">daily</em> system.
      </>
    ),
    items: [
      "2–3 minutes per day",
      "Real-world application",
      "No fluff, no theory",
    ],
  },
  {
    label: "The Result",
    headline: (
      <>
        You become<br />
        <em className="italic text-[#C07865]">someone else</em>.
      </>
    ),
    items: [
      "More grounded",
      "More clear",
      "Less reactive",
      "More in control of how you show up",
    ],
  },
];

export default function Framework() {
  return (
    <section
      id="framework"
      data-testid="framework-section"
      className="relative py-24 md:py-40"
      style={{ backgroundColor: "#F7F5F0" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-16 md:mb-24">
          <div className="md:col-span-5">
            <p className="overline mb-6">04 — The arc</p>
            <h2
              className="serif text-4xl md:text-5xl text-[#15243D] leading-[1.1]"
              style={{ fontWeight: 300 }}
            >
              From <em className="italic text-[#C07865]">reactive</em><br />
              to <em className="italic text-[#C07865]">rooted</em>.
            </h2>
          </div>
          <div className="md:col-span-6 md:col-start-7 md:pt-3">
            <p className="text-lg font-light leading-relaxed text-[#5A5D63]">
              Most people are not lacking knowledge — they are lacking a
              practice they can return to under pressure. Anchor is that
              practice. Here is the shape of the work, end to end.
            </p>
          </div>
        </div>

        <div className="space-y-px bg-[#15243D]/10">
          {steps.map((s, i) => (
            <div
              key={s.label}
              data-testid={`framework-step-${i}`}
              className="bg-[#F7F5F0] py-12 md:py-16 grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-start group"
            >
              <div className="md:col-span-3 flex items-baseline gap-4">
                <span
                  className="serif text-3xl text-[#C07865]"
                  style={{ fontWeight: 300 }}
                >
                  {String(i + 1).padStart(2, "0")}
                </span>
                <p className="text-xs tracking-[0.22em] uppercase text-[#15243D] font-medium pt-2">
                  {s.label}
                </p>
              </div>

              <div className="md:col-span-5">
                <h3
                  className="serif text-3xl md:text-4xl text-[#15243D] leading-[1.1]"
                  style={{ fontWeight: 300 }}
                >
                  {s.headline}
                </h3>
              </div>

              <ul className="md:col-span-4 space-y-3 md:pt-3">
                {s.items.map((item) => (
                  <li
                    key={item}
                    className="flex items-baseline gap-3 text-base font-light text-[#15243D]"
                  >
                    <span
                      aria-hidden
                      className="text-[#C07865] text-xs"
                    >
                      —
                    </span>
                    <span className="leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
